<template>
    <div>
         <div class="card-body">
             <form @submit="submitHandle($event)" action="" class="info-submit m-auto text-center">
                 <b-form-group class="custom-input" :label-for="input.id" v-for="(input, index) in inputConfig.form_input" :key="input.name">
                     <span class="placeholder">{{ input.placeholder }}</span>
                     
                     <div class="w-100">
                         <b-form-input
                             class='contact-input'
                             :id="input.id"
                             :autofocus="index == 0"
                             v-model="form[input.name]"
                             :state="checkStage(input)"
                             :name="input.name"
                             :ref="input.name"
                             :required="input.required"
                             :type="input.type"
                         />
                         <b-form-invalid-feedback :state="checkStage(input)">{{ getErrorMsg(input) }}</b-form-invalid-feedback>
                     </div>
                     
                 </b-form-group>
                 
                 <!-- <div class="custom-input" :class="{'validate-fail': !nameState}">
                     <div>
                         <span class="placeholder">Họ và tên đầy đủ:</span>
                         <div class="w-100">
                             <input name="name" @keydown="inputKeyDown" v-model="formContact.name" type="text">
                             <p class="m-0 text-fail">Họ và tên không đúng định dạng</p>
                         </div>
                     </div>
                 </div>
                 <div class="custom-input" :class="{'validate-fail': !ageState}">
                     <div>
                         <span class="placeholder">Tuổi:</span>
                         <div class="w-100">
                             <input name="age" @keydown="inputKeyDown" v-model="formContact.age" type="text">
                             <p class="m-0 text-fail">Tuổi không đúng định dạng</p>
                         </div>
                     </div>
                 </div>
                 <div class="custom-input" :class="{'validate-fail': !phoneRelativeState}">
                     <div>
                         <span class="placeholder">SĐT phụ huynh:</span>
                         <div class="w-100">
                             <input name="phone" @keydown="inputKeyDown" v-model="formContact.phoneRelative" type="text">
                             <p class="m-0 text-fail">Số điện thoại không đúng định dạng</p>
                         </div>
                     </div>
                 </div>
                 <div class="custom-input" :class="{'validate-fail': !emailState}">
                     <div>
                         <span class="placeholder">Email:</span>
                         <div class="w-100">
                             <input name="email" @keydown="inputKeyDown" v-model="formContact.email" type="email">
                             <p class="m-0 text-fail">Email không đúng định dạng</p>
                         </div>
                     </div>
                 </div> -->
                 <button type="submit" class="mt-5 m-auto border-0 bg-transparent">
                     <img class="mw-100" src="../../assets/newyear/submit-btn.png" alt="">
                 </button>
             </form>
         </div>
 
    </div>
 </template>
 
 <script>
 export default {
     mounted () {
         document.querySelectorAll('.custom-input').forEach(el => {
             el.addEventListener('click', function () {
                 this.querySelector('input').focus()
             })
         })
     },
     data() {
         return {
             nextButtonPress: false,
             startButtonPress: false,
             reInputPhone: false,
             form: {
                 examchoose: [],
                 examchoose2: [],
                 email: '',
                 name: '',
                 age: '',
                 phone: '',
                 confirmPhone: '',
                 step: 1, // Step 0. chọn đăng nhập tài khoản
                 level: 2,
                 class: '',
                 school: ''
             },
             formContact: {
                 name: '',
                 age: '',
                 phoneRelative: '',
                 email: ''
             },
             fistSubmit: false
         }
     },
     computed: {
         inputConfig () {
             return this.$store.getters['getStartWith']
         },
         nameState () {
             if (!this.fistSubmit) return true
             return this.formContact.name.trim()
         },
         ageState () {
             if (!this.fistSubmit) return true
             return this.formContact.age.trim() && (parseInt(this.formContact.age.trim()) > 0 && parseInt(this.formContact.age.trim()) < 100)
         },
         phoneRelativeState () {
             if (!this.fistSubmit) return true
             return this.formContact.phoneRelative && this.checkPhone(this.formContact.phoneRelative)
         },
         emailState () {
             if (!this.fistSubmit) return true
             return this.formContact.email && this.validEmail(this.formContact.email)
         },
     },
     watch: {
         'formContact': {
             handler (value) {
                 this.$store.dispatch('saveContact', JSON.stringify(value))
             },
             deep: true
         }
     },
     methods: {
         checkStage(input) {
             if (!this.nextButtonPress) {
                 return null
             }
 
             const value = this.$refs[input.name][0].value ?? ''
             if (
                 input.required &&
                 (value.trim() === '' || value.trim() === ' ')
             ) {
                 return false
             }
 
             if (
                 (input.name == 'phone' || input.name == 'sdt') &&
                 !this.checkPhone(value.trim())
             ) {
                 return false 
             }
 
             if (
                 (input.name == 'email') &&
                 !this.validEmail(value.trim())
             ) {
                 return false 
             }
 
             return true
             
         },
         getErrorMsg (input) {
             if (!this.nextButtonPress) {
                 return null
             }
             
             const value = this.$refs[input.name][0].value ?? ''
             if (
                 input.required &&
                 (value.trim() === '' || value.trim() === ' ')
             ) {
                 return input.require_msg
             }
 
             if (
                 (input.name == 'phone' || input.name == 'sdt') &&
                 !this.checkPhone(value.trim())
             ) {
                 return 'Số điện thoại không đúng định dạng!' 
             }
 
             if (
                 (input.name == 'email') &&
                 !this.validEmail(value.trim())
             ) {
                 return "Email không đúng định dạng!"
             }
         },
         
         inputKeyDown(e) {
             e.target.focus();
             console.log(e)
         },
         validEmail(email) {
             var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
             return re.test(email);
         },
         checkPhone(mobile) {
             let vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
             if(mobile !==''){
                 if (vnf_regex.test(mobile) == false) {
                     return false
                 } else {
                     return true
                 }
             }
         },
         submitHandle(event) {
             this.fistSubmit = true
             event.preventDefault();
             this.pushContact(this.form)
         },
         pushContact(data){
 
             const trackid = localStorage.getItem('_speakup_track')
 
             this.$http.post('/track/push-contact-v2',{
                 trackid: trackid,
                 data:{
                     source: document.location.href,
                     ...data
                 }
             })
             .then(res => {
                 if (res.data.code === 1) {
                    localStorage.setItem('_speakup_userInfo', JSON.stringify({...data, id: res.data.data}))
                    this.$store.commit('SET_PAGE', 2)
                 } else {
                     this.$bvToast.toast(res.data.message, {
                         title: `Có lỗi xảy ra !`,
                         variant: 'danger',
                         solid: true
                     })
                 }
             })
             .catch(error => {
                 console.log(error)
                 this.$bvToast.toast(error.message, {
                     title: `Có lỗi xảy ra !`,
                     variant: 'danger',
                     solid: true
                 })
             })
         }
     }
 }
 </script>
 
 <style lang="scss">
 
 .contact-input {
     height: 34px !important;
     margin-bottom: 0px !important;
     background-color: #ffffff52 !important;
 }
 
 
 .title-line1 {
     font-family: 'iCiel Crocante';
     font-size: 2rem;
     color: #fc7b32;
 }
 
 .title-line1 span {
     color: #127cf3;
 }
 
 .title-line2 {
     font-family: 'Montserrat-SemiBold';
     color: #0099ff;
     font-size: 1.2rem;
 }
 
 form {
     max-width: 630px;
 }
 
 .custom-input {
     width: 100%;
     background-color: #1ebcff;
     text-align: left;
     margin-bottom: 30px;
     border-radius: 50px;
     box-shadow: 0px 4px 6px -1px #0000005e;
     position: relative;
     overflow: hidden;
 }
 
 .custom-input::after {
     background-image: url(../../assets/newyear/input-item.png);
     content: '';
     height: 37px;
     width: 50px;
     display: block;
     position: absolute;
     bottom: 0;
     right: 0;
 }
 
 .custom-input>div {
     display: flex;
     border-radius: 10px;
     padding: 10px 20px;
 }
 
 .custom-input .placeholder {
     font-family: 'Nunito', sans-serif;
     color: #fff;
     width: 254px;
     font-size: 1.1rem;
     background-color: unset;
     opacity: 1;
     cursor: unset;
     min-width: fit-content;
 }
 
 .custom-input input {
     width: 100%;
     border: none;
     background-color: #1ebcff;
 }
 
 .info-submit {
     margin-top: 50px !important;
     margin-bottom: 50px !important;
 }
 
 .validate-fail .text-fail {
     display: block;
 }
 
 .text-fail {
     display: none;
     color: #ef2323;
     font-style: italic;
     font-size: 0.9rem;
 }
 
 
 @media (max-width: 768px) {
     .title-line1 {
         font-size: 1.6rem;
     }
 }
 
 
 @media (max-width: 576px) {
     .custom-input .placeholder {
         font-size: 1rem;
     }
 
     header button img {
         height: 40px;
     }
 }
 
 </style>